exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-index-page-js": () => import("./../../../src/templates/index-page.js" /* webpackChunkName: "component---src-templates-index-page-js" */),
  "component---src-templates-kontakt-js": () => import("./../../../src/templates/kontakt.js" /* webpackChunkName: "component---src-templates-kontakt-js" */),
  "component---src-templates-showroom-js": () => import("./../../../src/templates/showroom.js" /* webpackChunkName: "component---src-templates-showroom-js" */),
  "component---src-templates-udrzba-js": () => import("./../../../src/templates/udrzba.js" /* webpackChunkName: "component---src-templates-udrzba-js" */)
}

